// extracted by mini-css-extract-plugin
export default {"container":"GeofenceTooltip_container__BM8ml","text":"GeofenceTooltip_text__+wxHN"};